export default function FabricIcon({ fabricId, imageUrl, isActive, onClick, title = null }) {
    return(
        isActive
            ? <img className="pointer color-item active" src={imageUrl} title={title} onClick={() => onClick(fabricId)} />
            : <img className="pointer color-item" src={imageUrl} title={title} onClick={() => onClick(fabricId)} />
    )
}